/* global window */
import * as React from 'react';
import ReactDOM from 'react-dom';

// paypal script is cors protected and needs to be brought in globally in the public index file
// because who cares about modern dev practices :D
export default window.paypal.Button.driver('react', { React, ReactDOM });



// WEBPACK FOOTER //
// ./src/cards/templates/payBalanceSections/PayPalButton.js